import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const GET_SURVEY_BY_ID_QUERY_KEY = 'survey/<id>';

export type GetSurveyByIdSurveyType = 'eventRegistration' | 'custom' | 'donation' | 'satisfaction';

export function useGetSurveyById<T extends Api.ISurvey = Api.ISurvey>({
	impersonationContext,
	enabled = true,
	refetchOnWindowFocus = false,
	surveyId,
	surveyType,
}: {
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
	surveyId: string;
	refetchOnWindowFocus?: boolean;
	surveyType?: GetSurveyByIdSurveyType;
}) {
	const userSession = useUserSession();
	let urlPath = `survey/${surveyId}`;

	if (surveyType) {
		urlPath = `survey/${surveyType}/${surveyId}`;
	}

	return useQuery<T>({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<T>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath,
					queryParams: {
						expand: 'options',
					},
				}),
				'GET'
			);
		},
		queryKey: [GET_SURVEY_BY_ID_QUERY_KEY, surveyType, surveyId, impersonationContext?.account?.id],
		refetchOnWindowFocus,
	});
}

export const invalidateSurveyById = () => {
	reactQueryClient.invalidateQueries({
		queryKey: [GET_SURVEY_BY_ID_QUERY_KEY],
	});
};
